module.exports = __webpack_public_path__ + "static/pic22-de79e317fe1090c765eca463da52b8a8.jpg";